import React, { useState, useEffect } from 'react'
import { Table, Button, notification, Popconfirm } from 'antd';
import axios from 'axios';
import { CheckCircleTwoTone, SyncOutlined, WarningTwoTone } from '@ant-design/icons';
import baseUrl, { betaBaseUrl } from '../config';
import AddConstraint from '../Components/ModalComponent/AddConstraint';
import DeleteConstraint from '../Components/ModalComponent/DeleteConstraint';
import AddPanelCode from '../Components/ModalComponent/AddPanelCode';
import { useTranslation } from 'react-i18next';

const Constraint = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false)
    const [modifiedData, setModifiedData] = useState([])
    const [modifiedData1, setModifiedData1] = useState([])
    const [modifiedData2, setModifiedData2] = useState([])
    const [modifiedData3, setModifiedData3] = useState([])
    const [modifiedData4, setModifiedData4] = useState([])

    const [modalOpen, setModalOpen] = useState(false)
    const [modalOpen1, setModalOpen1] = useState(false)
    const [modalOpen2, setModalOpen2] = useState(false)
    const [data, setData] = useState([])
    const [data1, setData1] = useState([])
    const [data2, setData2] = useState([])
    const [data3, setData3] = useState([])
    const [data4, setData4] = useState([])
    const [selectedRow, setSelectedRow] = useState({})

    const [isBeta, setIsBeta] = useState(() => {
        const storedValue = localStorage.getItem('isBeta');
        return storedValue ? JSON.parse(storedValue) : false;
    });

    const [refresh, setRefresh] = useState(false)

    const [api, contextHolder] = notification.useNotification();
    const openNotification = (placement, value, icon) => {
        api.info({
            message: t('constraint.systemInfo'),
            description: value,
            placement,
            icon: icon || <CheckCircleTwoTone twoToneColor="#52c41a" />,
            duration: 2
        });
    };

    const [migrating, setMigrating] = useState(false)

    const handleMainToBetaMigration = async () => {
        setMigrating(true)
        try {
            await axios.post(`${baseUrl}/mainToBetaMigration`);
            openNotification('top', 'Veriler Beta ortamına başarıyla aktarıldı');
            setRefresh(r => !r);
        } catch (error) {
            openNotification('top', `Hata: ${error.message}`, <WarningTwoTone twoToneColor="red" />);
        } finally {
            setMigrating(false)
        }
    };

    const handleBetaToMainMigration = async () => {
        setMigrating(true)
        try {
            await axios.post(`${baseUrl}/betaToMainMigration`);
            openNotification('top', 'Veriler Canlı ortama başarıyla aktarıldı');
            setRefresh(r => !r);
        } catch (error) {
            openNotification('top', `Hata: ${error.message}`, <WarningTwoTone twoToneColor="red" />);
        } finally {
            setMigrating(false)
        }
    };

    // Ortam değiştirme fonksiyonu
    const toggleEnvironment = () => {
        const newValue = !isBeta;
        setIsBeta(newValue);
        localStorage.setItem('isBeta', JSON.stringify(newValue));

        openNotification('top', `${newValue ? 'Beta' : 'Canlı'} ortama geçildi`,
            <SyncOutlined spin style={{ color: newValue ? '#1890ff' : '#52c41a' }} />);

        setRefresh(!refresh);
    };

    const getData = async () => {
        setLoading(true)
        const apiEndpoint = isBeta ? `${betaBaseUrl}/listKisit` : `${baseUrl}/listKisit`;

        await axios.get(apiEndpoint)
            .then(res => {
                if (res.data) {
                    let rearPanelveri = [];
                    let kapiIcSacVeri = [];
                    let topBottomVeri = [];
                    let sidePanelVeri = [];
                    let backPanelVeri = [];

                    rearPanelveri = res.data.filter(item => item.panelType === "rearPanel")
                    kapiIcSacVeri = res.data.filter(item => item.panelType === "kapiIcSac")
                    topBottomVeri = res.data.filter(item => item.panelType === "topBottom")
                    sidePanelVeri = res.data.filter(item => item.panelType === "sidePanel")
                    backPanelVeri = res.data.filter(item => item.panelType === "backPanel")

                    setData(rearPanelveri)
                    setData1(kapiIcSacVeri)
                    setData2(topBottomVeri)
                    setData3(sidePanelVeri)
                    setData4(backPanelVeri)
                }
            }
            )
            .catch(err => {
                console.log(err);
                openNotification('top', `Veri yüklenirken hata oluştu: ${err.message}`,
                    <WarningTwoTone twoToneColor="red" />);
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        getData()
    }, [refresh, isBeta])


    const addPanelCodeButton = (record) => {
        setModalOpen2(true)
        setSelectedRow(record)
    }

    useEffect(() => {
        const dataList = data?.map((item, index) => ({
            key: index + 1,
            rearPanel: item?.code,
            renk: item?.renk,
            number: item?.number
        }))
        const dataList1 = data1?.map((item, index) => ({
            key: index + 1,
            kapiIcSac: item?.code,
            renk: item?.renk,
            number: item?.number
        }))
        const dataList2 = data2?.map((item, index) => ({
            key: index + 1,
            topBottom: item?.code,
            renk: item?.renk,
            number: item?.number
        }))
        const dataList3 = data3?.map((item, index) => ({
            key: index + 1,
            sidePanel: item?.code,
            renk: item?.renk,
            number: item?.number
        }))
        const dataList4 = data4?.map((item, index) => ({
            key: index + 1,
            backPanel: item?.code,
            renk: item?.renk,
            number: item?.number
        }))

        setModifiedData([...dataList]);
        setModifiedData1([...dataList1]);
        setModifiedData2([...dataList2]);
        setModifiedData3([...dataList3]);
        setModifiedData4([...dataList4]);

    }, [data, data1, data2, data3, data4])

    const columns = [
        {
            title: 'Rear Panel',
            dataIndex: 'rearPanel',
            key: 'rearPanel',
            align: "center",
            render(text, record) {
                return {
                    props: {
                        style: { background: record.renk }
                    },
                    children: <div className='flex justify-between'>
                        <div className='flex m-auto'>{text}</div>
                        {
                            record.number !== " " ?
                                <div onClick={() => addPanelCodeButton(record)} className="w-6 h-6 rounded-full bg-black text-white flex items-center justify-center bg-opacity-25 text-opacity-70 cursor-pointer hover:bg-white hover:text-black">{record.number}</div>
                                : null
                        }
                    </div>
                };
            }
        },
    ];
    const columns1 = [
        {
            title: 'Kapı İç Sac',
            dataIndex: 'kapiIcSac',
            key: 'kapiIcSac',
            align: "center",
            render(text, record) {
                return {
                    props: {
                        style: { background: record.renk }
                    },
                    children: <div className='flex justify-between'>
                        <div className='flex m-auto'>{text}</div>
                        {
                            record.number !== " " ?
                                <div onClick={() => addPanelCodeButton(record)} className="w-6 h-6 rounded-full bg-black text-white flex items-center justify-center bg-opacity-25 text-opacity-70 cursor-pointer hover:bg-white hover:text-black">{record.number}</div>
                                : null
                        }
                    </div>
                };
            }
        },
    ];
    const columns2 = [
        {
            title: 'Top Bottom',
            dataIndex: 'topBottom',
            key: 'topBottom',
            align: "center",
            render(text, record) {
                return {
                    props: {
                        style: { background: record.renk }
                    },
                    children: <div className='flex justify-between'>
                        <div className='flex m-auto'>{text}</div>
                        {
                            record.number !== " " ?
                                <div onClick={() => addPanelCodeButton(record)} className="w-6 h-6 rounded-full bg-black text-white flex items-center justify-center bg-opacity-25 text-opacity-70 cursor-pointer hover:bg-white hover:text-black">{record.number}</div>
                                : null
                        }
                    </div>
                };
            }
        },
    ];
    const columns3 = [
        {
            title: 'Side Panel',
            dataIndex: 'sidePanel',
            key: 'sidePanel',
            align: "center",
            render(text, record) {
                return {
                    props: {
                        style: { background: record.renk }
                    },
                    children: <div className='flex justify-between'>
                        <div className='flex m-auto'>{text}</div>
                        {
                            record.number !== " " ?
                                <div onClick={() => addPanelCodeButton(record)} className="w-6 h-6 rounded-full bg-black text-white flex items-center justify-center bg-opacity-25 text-opacity-70 cursor-pointer hover:bg-white hover:text-black">{record.number}</div>
                                : null
                        }
                    </div>
                };
            }
        },
    ];
    const columns4 = [
        {
            title: 'Back Panel',
            dataIndex: 'backPanel',
            key: 'backPanel',
            align: "center",
            render(text, record) {
                return {
                    props: {
                        style: { background: record.renk }
                    },
                    children: <div className='flex justify-between'>
                        <div className='flex m-auto'>{text}</div>
                        {
                            record.number !== " " ?
                                <div onClick={() => addPanelCodeButton(record)} className="w-6 h-6 rounded-full bg-black text-white flex items-center justify-center bg-opacity-25 text-opacity-70 cursor-pointer hover:bg-white hover:text-black">{record.number}</div>
                                : null
                        }
                    </div>
                };
            }
        },
    ];

    return (
        <>
            {contextHolder}
            <AddConstraint
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                modifiedData={modifiedData}
                modifiedData1={modifiedData1}
                modifiedData2={modifiedData2}
                modifiedData3={modifiedData3}
                modifiedData4={modifiedData4}
                refresh={refresh}
                setRefresh={setRefresh}
                isBeta={isBeta}
            />
            <AddPanelCode
                modalOpen2={modalOpen2}
                setModalOpen2={setModalOpen2}
                refresh={refresh}
                setRefresh={setRefresh}
                selectedRow={selectedRow}
            />
            <DeleteConstraint
                modalOpen1={modalOpen1}
                setModalOpen1={setModalOpen1}
                modifiedData={modifiedData}
                setRefresh={setRefresh}
                refresh={refresh}
                isBeta={isBeta}
            />
            <div className='flex flex-col mr-auto ml-auto mt-10 w-11/12 gap-2'>
                <div className='flex flex-row gap-2 justify-between'>
                    <div className='flex gap-2'>
                        <div><Button className='bg-white text-black' onClick={() => setModalOpen(true)}>{t('constraint.addPanel')}</Button></div>
                        <div><Button className='bg-white text-black' onClick={() => setModalOpen1(true)}>{t('constraint.deletePanel')}</Button></div>
                    </div>
                    <div className='flex gap-2'>
                        {isBeta ? (
                            <Popconfirm
                                title={t('constraint.transferToMain')}
                                description={t('constraint.transferToMainConfirm')}
                                okText={t('constraint.yes')}
                                cancelText={t('constraint.no')}
                                onConfirm={handleBetaToMainMigration}
                            >
                                <Button className="bg-orange-500 text-white" loading={migrating}>
                                    {t('constraint.transferToMain')}
                                </Button>
                            </Popconfirm>
                        ) : (
                            <Button
                                className="bg-blue-500 text-white"
                                loading={migrating}
                                onClick={handleMainToBetaMigration}
                            >
                                {t('constraint.transferToBeta')}
                            </Button>
                        )}
                        <Button
                            className={`${isBeta ? 'bg-blue-500' : 'bg-green-500'} text-white`}
                            onClick={toggleEnvironment}
                        >
                            {isBeta ? t('constraint.switchToLive') : t('constraint.switchToBeta')}
                        </Button>
                    </div>
                </div>

                <div className='flex flex-row w-full'>
                    <div className='flex w-1/5'>
                        <Table
                            dataSource={modifiedData}
                            columns={[{
                                title: t('constraint.panels.rearPanel'),
                                dataIndex: 'rearPanel',
                                key: 'rearPanel',
                                align: "center",
                                render(text, record) {
                                    return {
                                        props: {
                                            style: { background: record.renk }
                                        },
                                        children: <div className='flex justify-between'>
                                            <div className='flex m-auto'>{text}</div>
                                            {
                                                record.number !== " " ?
                                                    <div onClick={() => addPanelCodeButton(record)} className="w-6 h-6 rounded-full bg-black text-white flex items-center justify-center bg-opacity-25 text-opacity-70 cursor-pointer hover:bg-white hover:text-black">{record.number}</div>
                                                    : null
                                            }
                                        </div>
                                    };
                                }
                            }]}
                            sticky
                            loading={loading}
                            pagination={false}
                            size="small"
                            bordered
                        />
                    </div>
                    <div className='flex w-1/5'>
                        <Table
                            dataSource={modifiedData1}
                            columns={[{
                                title: t('constraint.panels.doorInnerSheet'),
                                dataIndex: 'kapiIcSac',
                                key: 'kapiIcSac',
                                align: "center",
                                render(text, record) {
                                    return {
                                        props: {
                                            style: { background: record.renk }
                                        },
                                        children: <div className='flex justify-between'>
                                            <div className='flex m-auto'>{text}</div>
                                            {
                                                record.number !== " " ?
                                                    <div onClick={() => addPanelCodeButton(record)} className="w-6 h-6 rounded-full bg-black text-white flex items-center justify-center bg-opacity-25 text-opacity-70 cursor-pointer hover:bg-white hover:text-black">{record.number}</div>
                                                    : null
                                            }
                                        </div>
                                    };
                                }
                            }]}
                            sticky
                            loading={loading}
                            pagination={false}
                            size="small"
                            bordered
                        />
                    </div>
                    <div className='flex w-1/5'>
                        <Table
                            dataSource={modifiedData2}
                            columns={[{
                                title: t('constraint.panels.topBottom'),
                                dataIndex: 'topBottom',
                                key: 'topBottom',
                                align: "center",
                                render(text, record) {
                                    return {
                                        props: {
                                            style: { background: record.renk }
                                        },
                                        children: <div className='flex justify-between'>
                                            <div className='flex m-auto'>{text}</div>
                                            {
                                                record.number !== " " ?
                                                    <div onClick={() => addPanelCodeButton(record)} className="w-6 h-6 rounded-full bg-black text-white flex items-center justify-center bg-opacity-25 text-opacity-70 cursor-pointer hover:bg-white hover:text-black">{record.number}</div>
                                                    : null
                                            }
                                        </div>
                                    };
                                }
                            }]}
                            sticky
                            loading={loading}
                            pagination={false}
                            size="small"
                            bordered
                        />
                    </div>
                    <div className='flex w-1/5'>
                        <Table
                            dataSource={modifiedData3}
                            columns={[{
                                title: t('constraint.panels.sidePanel'),
                                dataIndex: 'sidePanel',
                                key: 'sidePanel',
                                align: "center",
                                render(text, record) {
                                    return {
                                        props: {
                                            style: { background: record.renk }
                                        },
                                        children: <div className='flex justify-between'>
                                            <div className='flex m-auto'>{text}</div>
                                            {
                                                record.number !== " " ?
                                                    <div onClick={() => addPanelCodeButton(record)} className="w-6 h-6 rounded-full bg-black text-white flex items-center justify-center bg-opacity-25 text-opacity-70 cursor-pointer hover:bg-white hover:text-black">{record.number}</div>
                                                    : null
                                            }
                                        </div>
                                    };
                                }
                            }]}
                            sticky
                            loading={loading}
                            pagination={false}
                            size="small"
                            bordered
                        />
                    </div>
                    <div className='flex w-1/5'>
                        <Table
                            dataSource={modifiedData4}
                            columns={[{
                                title: t('constraint.panels.backPanel'),
                                dataIndex: 'backPanel',
                                key: 'backPanel',
                                align: "center",
                                render(text, record) {
                                    return {
                                        props: {
                                            style: { background: record.renk }
                                        },
                                        children: <div className='flex justify-between'>
                                            <div className='flex m-auto'>{text}</div>
                                            {
                                                record.number !== " " ?
                                                    <div onClick={() => addPanelCodeButton(record)} className="w-6 h-6 rounded-full bg-black text-white flex items-center justify-center bg-opacity-25 text-opacity-70 cursor-pointer hover:bg-white hover:text-black">{record.number}</div>
                                                    : null
                                            }
                                        </div>
                                    };
                                }
                            }]}
                            sticky
                            loading={loading}
                            pagination={false}
                            size="small"
                            bordered
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Constraint